export const isNumeric = (num) => /^-{0,1}\d*\.{0,1}\d+$/.test(num);

const numberFormat = new Intl.NumberFormat('en-US');
export const numberFormatUtil = (num) => {
  return numberFormat.format(num);
};
